__turbopack_context__.v({
  "ant-select-selector": "_9tonea_ant-select-selector",
  "captcha": "_9tonea_captcha",
  "custom": "_9tonea_custom",
  "select": "_9tonea_select",
  "wrapper": "_9tonea_wrapper",
});
